import { render, staticRenderFns } from "./GB28181Create.vue?vue&type=template&id=15a7de93&"
import script from "./GB28181Create.vue?vue&type=script&lang=js&"
export * from "./GB28181Create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports